/* eslint-disable indent */
import React from 'react';

const PlantMarker = ({ classes }) => {
  return <div className={classes.plantMarkerIconWrapper} />;
};

export default PlantMarker;
